// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sharepoint-folder-card {
  margin-top: 10px;
  padding: 10px 12px;
  background-color: var(--surface-light);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sharepoint-folder-card-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-muted, #6b7280);
}

.sharepoint-folder-card-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: var(--primary);
  text-decoration: none;
  font-size: 12px;
  line-height: 1.5;
  transition: opacity 0.2s;
}

.sharepoint-folder-card-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.sharepoint-folder-card-url {
  word-break: break-all;
  flex: 1 1 auto;
  min-width: 0;
}

.sharepoint-folder-card-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.custom-folder-input {
  width: 100%;
  padding: 10px 12px;
  margin-top: 8px;
  border-radius: 8px;
  border: 1px solid var(--border-light);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
}

.folder-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.folder-section-header .form-label {
  margin: 0;
}

.folder-custom-toggle--header {
  margin: 0;
  flex-shrink: 0;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.folder-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}

.folder-custom-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: transparent;
  border: none;
  color: var(--primary);
  font-size: 12px;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  border-radius: 4px;
}

.folder-custom-toggle:hover:not(:disabled) {
  background: var(--hover-bg, rgba(0, 0, 0, 0.04));
}

.folder-custom-toggle:disabled {
  opacity: 0.5;
  cursor: default;
}

.folder-custom-toggle .material-icons-round {
  font-size: 14px;
}

.folder-validation-hint {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: var(--warning-text, #e67700);
}

.folder-validation-hint--error {
  color: var(--error-text, #d13438);
}

.folder-create-row {
  display: flex;
  gap: 6px;
  align-items: stretch;
  margin-top: 8px;
}

.folder-create-row .custom-folder-input {
  margin-top: 0;
  flex: 1;
}

.folder-create-submit {
  padding: 0 14px;
  border-radius: 8px;
  border: none;
  background: var(--primary);
  color: #fff;
  font-size: 13px;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  white-space: nowrap;
}

.folder-create-submit:disabled {
  opacity: 0.5;
  cursor: default;
}

.info-banner--sharepoint-warning {
  border-left: 3px solid var(--warning-text);
}

.info-banner--sharepoint-warning .banner-icon {
  color: var(--warning-text);
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/SharePointFolderPicker/SharePointFolderPicker.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".sharepoint-folder-card {\n  margin-top: 10px;\n  padding: 10px 12px;\n  background-color: var(--surface-light);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sharepoint-folder-card-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text-muted, #6b7280);\n}\n\n.sharepoint-folder-card-link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  color: var(--primary);\n  text-decoration: none;\n  font-size: 12px;\n  line-height: 1.5;\n  transition: opacity 0.2s;\n}\n\n.sharepoint-folder-card-link:hover {\n  opacity: 0.8;\n  text-decoration: underline;\n}\n\n.sharepoint-folder-card-url {\n  word-break: break-all;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.sharepoint-folder-card-icon {\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.custom-folder-input {\n  width: 100%;\n  padding: 10px 12px;\n  margin-top: 8px;\n  border-radius: 8px;\n  border: 1px solid var(--border-light);\n  font-size: 14px;\n  font-family: 'Inter', sans-serif;\n}\n\n.folder-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.folder-section-header .form-label {\n  margin: 0;\n}\n\n.folder-custom-toggle--header {\n  margin: 0;\n  flex-shrink: 0;\n  max-width: 60%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.folder-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.folder-custom-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: transparent;\n  border: none;\n  color: var(--primary);\n  font-size: 12px;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.folder-custom-toggle:hover:not(:disabled) {\n  background: var(--hover-bg, rgba(0, 0, 0, 0.04));\n}\n\n.folder-custom-toggle:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.folder-custom-toggle .material-icons-round {\n  font-size: 14px;\n}\n\n.folder-validation-hint {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--warning-text, #e67700);\n}\n\n.folder-validation-hint--error {\n  color: var(--error-text, #d13438);\n}\n\n.folder-create-row {\n  display: flex;\n  gap: 6px;\n  align-items: stretch;\n  margin-top: 8px;\n}\n\n.folder-create-row .custom-folder-input {\n  margin-top: 0;\n  flex: 1;\n}\n\n.folder-create-submit {\n  padding: 0 14px;\n  border-radius: 8px;\n  border: none;\n  background: var(--primary);\n  color: #fff;\n  font-size: 13px;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.folder-create-submit:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.info-banner--sharepoint-warning {\n  border-left: 3px solid var(--warning-text);\n}\n\n.info-banner--sharepoint-warning .banner-icon {\n  color: var(--warning-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
